export enum UserRole {
  ADMIN = "admin",
  ROOT = "root",
  SELLER = "seller",
}
